<template>
    <BaseDialog
        :visible="dialog"
        :type="type"
        :form="form"
        title="ticketset"
        @close="dialog=false"
        @process="processForm"
    >
        <v-text-field
                v-model="form.name"
                type="text"
                label="Jméno sady vstupenek"
                :rules="formRules.name"
        />
        <v-text-field
                v-model="form.customName"
                type="text"
                label="Hláška při kontrole"
        />
        <v-checkbox dense hide-details
                    v-model="form.validate"
                    label="Aktivovat hlášku při kontrole"
        />
    </BaseDialog>
</template>

<script>
    import BaseDialogMixin from '../../mixins/BaseDialogMixin'

    export default {
        mixins: [BaseDialogMixin],

        data: () => ({
            form: {
                id: 0,
                name: '',
                customName: '',
                validate: false
            },
            formRules: {
                name: [v => v !== '' || 'Vyplňte hodnotu'],
            }
        }),
    }
</script>
